import type { FieldConfiguration } from "../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ReportField } from "../../../../../../../api/types/svTypes.ts";

export const getTrackedTabularDimensionProperties = (fields: ReportField[]): DimensionInfoTracked[] => {
  return fields.map((d) => {
    const field: DimensionInfoTracked = {
      showLogoIcon: d.config.showLogoIcon,
      format: d.config.format,
      grouping: d.config.grouping,
      customLabel: d.config.customLabel,
      hideBlankValues: d.config.hideBlankValues,
      hideZeroValues: d.config.hideZeroValues,
      aggregation: d.config.aggregation,
      customId: d.config.customId,
    };

    return field;
  });
};

type DimensionInfoTracked = Pick<
  FieldConfiguration,
  | "showLogoIcon"
  | "format"
  | "grouping"
  | "customLabel"
  | "hideBlankValues"
  | "hideZeroValues"
  | "aggregation"
  | "customId"
>;
